export default "__VITE_ASSET__fmINu5TY__"